import React from 'react';

import { AuthUser } from '../auth';
import './Header.css';

interface HeaderProps {
  user: AuthUser | null;
}

/** Application header with logo, title, and authenticated user display. */
const Header: React.FC<HeaderProps> = ({ user }) => (
  <header className="header">
    <img
      className="header-logo"
      src={`${process.env.PUBLIC_URL}/logo.png`}
      alt="SkyWrench Logo"
    />
    <h1 className="header-title">
      Sky<span>Wrench</span>
    </h1>
    {user && (
      <div className="header-user">
        <span className="header-user-name">{user.name}</span>
      </div>
    )}
  </header>
);

export default Header;
